"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var priceNodes = document.querySelectorAll('.type-product .entry-summary > p.price');
    var observer = new MutationObserver(callback);
    var options = {
        childList: true,
        attributes: false,
        characterData: false,
        subtree: false,
        attributeOldValue: false,
        characterDataOldValue: false
    };
    function callback(mutations) {
        var $newNodes = $(mutations[0].addedNodes[0]);
        if ($newNodes.hasClass('woocommerce-Price-amount')) {
            $newNodes.contents().each(function (index, obj) {
                if ($(obj)[0].nodeType === 3 && $(obj)[0].textContent === '0.00') {
                    $(obj)[0].textContent = '--';
                }
            });
        }
    }
    priceNodes.forEach(function (node) { return observer.observe(node, options); });
};
exports.init = init;
